import React, { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get, post, put } from '../../redux/modules/articles';
import FieldInput from '../../components/Field/Field';
import Image from '../../components/image/Image';
import Editor from '../../components/editor/Editor';
import * as Validations from '../../validations/validations';

const FORM_NAME = 'PartnerForm';

class PartnerForm extends PureComponent {

  handlerSubmit(values) {
    const { getAction, putAction, postAction, close } = this.props;
    const newData = { ...values };
    if (newData.id > 0) {
      return putAction(newData.id, newData)
        .then(() => {
          close();
          getAction();
        });
    }
    return postAction(newData).then(() => {
      close();
      getAction();
    });
  }

  render() {
    const { handleSubmit, pristine, reset, submitting } = this.props;
    return (
      <form
        className="planet-form"
        onSubmit={handleSubmit(this.handlerSubmit.bind(this))}>

        <div className="row">
          <div className="col-xs-5">
            <Field
              label="Title"
              name="title"
              validate={[Validations.required, Validations.minLength2]}
              component={FieldInput}/>

            <Field
              label="Link"
              name="link"
              validate={[Validations.required, Validations.minLength5]}
              component={FieldInput}/>
          </div>

          <div className="col-xs-7">
            <Field
              validate={[Validations.required]}
              name="image"
              component={Image}/>
          </div>

          <div className="row">
            <div className="col-xs-12">
              <Field
                validate={[Validations.required, Validations.minLength2, Validations.maxMediumText]}
                name="body"
                component={Editor}/>
            </div>
          </div>

          <div className="clearfix"></div>
          <div className="col-lg-12 text-right form-buttons">
            <button disabled={pristine || submitting} loading={submitting} type="submit"
                    className="btn btn-xl">Save
            </button>
            <button disabled={pristine || submitting} loading={submitting} type="button" className="btn btn-xl"
                    onClick={reset}>Clear
            </button>
          </div>
        </div>
      </form>
    );
  }
}

PartnerForm.propTypes = {};
PartnerForm.defaultProps = {};

PartnerForm = reduxForm({
  form: FORM_NAME
})(PartnerForm);

export default connect(
  (state, props) => {
    return {
      enableReinitialize: true,
      initialValues: props.defaultValues
    };
  },
  (dispatch) => {
    return bindActionCreators({
      getAction: get,
      postAction: post,
      putAction: put
    }, dispatch);
  }
)(PartnerForm);



// WEBPACK FOOTER //
// ./src/forms/article/index.js